import { useEffect } from "react";
import * as PropTypes from "prop-types";
import useLottie from "../hooks/useLottie";
const Lottie = (props) => {
    var _a;
    const { style, ...lottieProps } = props;
    /**
     * Initialize the 'useLottie' hook
     */
    const { View, play, stop, pause, setSpeed, goToAndStop, goToAndPlay, setDirection, playSegments, setSubframe, getDuration, destroy, animationLoaded, animationItem, } = useLottie(lottieProps, style);
    /**
     * Make the hook variables/methods available through the provided 'lottieRef'
     */
    useEffect(() => {
        if (props.lottieRef) {
            props.lottieRef.current = {
                play,
                stop,
                pause,
                setSpeed,
                goToAndPlay,
                goToAndStop,
                setDirection,
                playSegments,
                setSubframe,
                getDuration,
                destroy,
                animationLoaded,
                animationItem,
            };
        }
    }, [(_a = props.lottieRef) === null || _a === void 0 ? void 0 : _a.current]);
    return View;
};
Lottie.propTypes = {
    animationData: PropTypes.shape(undefined).isRequired,
    loop: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    autoplay: PropTypes.bool,
    initialSegment: PropTypes.arrayOf(PropTypes.number.isRequired),
    onComplete: PropTypes.func,
    onLoopComplete: PropTypes.func,
    onEnterFrame: PropTypes.func,
    onSegmentStart: PropTypes.func,
    onConfigReady: PropTypes.func,
    onDataReady: PropTypes.func,
    onDataFailed: PropTypes.func,
    onLoadedImages: PropTypes.func,
    onDOMLoaded: PropTypes.func,
    onDestroy: PropTypes.func,
    style: PropTypes.shape(undefined),
};
Lottie.defaultProps = {
    loop: true,
    autoplay: true,
    initialSegment: null,
    onComplete: null,
    onLoopComplete: null,
    onEnterFrame: null,
    onSegmentStart: null,
    onConfigReady: null,
    onDataReady: null,
    onDataFailed: null,
    onLoadedImages: null,
    onDOMLoaded: null,
    onDestroy: null,
    style: undefined,
};
export default Lottie;
